import { api } from './client';

export interface ReminderTemplate {
  id: string;
  companyId: string;
  name: string;
  messageTemplate: string;
  isActive: boolean;
  sortOrder: number;
  sitesCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface ReminderTemplateForSite {
  id: string;
  name: string;
  messageTemplate: string;
}

export interface TemplateSiteAssignment {
  id: string;
  code: string;
  name: string;
  isAssigned: boolean;
}

export const reminderTemplatesApi = {
  getAll: (includeInactive = false): Promise<ReminderTemplate[]> =>
    api.get(`/reminder-templates${includeInactive ? '?includeInactive=true' : ''}`),

  getForSite: (): Promise<ReminderTemplateForSite[]> =>
    api.get('/reminder-templates/for-site'),

  getSiteAssignments: (id: string): Promise<TemplateSiteAssignment[]> =>
    api.get(`/reminder-templates/${id}/sites`),

  updateSiteAssignments: (id: string, siteIds: string[]): Promise<TemplateSiteAssignment[]> =>
    api.put(`/reminder-templates/${id}/sites`, { siteIds }),

  bulkAssignToSite: (siteId: string, templateIds: string[]): Promise<void> =>
    api.put(`/reminder-templates/bulk-assign/${siteId}`, { siteIds: templateIds }),

  create: (data: { name: string; messageTemplate: string; isActive?: boolean; sortOrder?: number }): Promise<ReminderTemplate> =>
    api.post('/reminder-templates', data),

  update: (id: string, data: Partial<{ name: string; messageTemplate: string; isActive: boolean; sortOrder: number }>): Promise<ReminderTemplate> =>
    api.patch(`/reminder-templates/${id}`, data),

  deactivate: (id: string): Promise<ReminderTemplate> =>
    api.delete(`/reminder-templates/${id}`),

  reactivate: (id: string): Promise<ReminderTemplate> =>
    api.patch(`/reminder-templates/${id}/reactivate`, {}),
};
